import { Injectable } from '@angular/core';
import { Order, QueryEntity } from '@datorama/akita';
import { compareEntities, isEquals } from '@lycoris-nubila/ngx-lycoris';
import { isNil, reject, uniqBy } from 'lodash-es';
import { Observable } from 'rxjs';
import { distinctUntilChanged, map, shareReplay } from 'rxjs/operators';

import { MessageRepositoryPort } from 'application/message/port/message-repository.port';
import { ObserveMessagesQuery } from 'application/message/query/observe-messages.query';
import { Message } from 'domain/message/message';
import { MessageState, MessageStore } from 'repository/message/message.store';

import { CacheObservable } from '../../app-decorators';

@Injectable()
export class MessageRepositoryAdapter
	extends QueryEntity<MessageState>
	implements MessageRepositoryPort
{
	constructor(protected store: MessageStore) {
		super(store);
	}

	@CacheObservable()
	public observeMessages(query: ObserveMessagesQuery): Observable<Message[]> {
		return this.selectAll({
			filterBy: (entity) =>
				(query.isAuthorCoachee
					? entity.participantsId.includes(query.authorId) ||
					  (isEquals(entity.authorId, query.authorId) &&
							entity.participantsId.some((pi) => query.participantsId.includes(pi)))
					: isEquals(entity.authorId, query.authorId) &&
					  entity.participantsId.some((pi) => query.participantsId.includes(pi))) ||
				(query.participantsId.includes(entity.authorId) &&
					entity.participantsId.includes(query.authorId)),
			sortByOrder: Order.ASC,
			sortBy: 'date',
		}).pipe(
			map((documents) =>
				documents.map((document) => this.store.asEntity(document))
			),
			distinctUntilChanged(compareEntities),
			shareReplay({ bufferSize: 1, refCount: true })
		);
	}

	public async saveMessages(entities: Message[]): Promise<void> {
		this.store.upsertMany(
			uniqBy(
				reject(entities, isNil).map((e) => this.store.asDocument(e)),
				'id'
			)
		);
	}
}
